import { render, staticRenderFns } from "./MduiRadio.vue?vue&type=template&id=dd8d961a&scoped=true"
import script from "./MduiRadio.vue?vue&type=script&lang=js"
export * from "./MduiRadio.vue?vue&type=script&lang=js"
import style0 from "./MduiRadio.vue?vue&type=style&index=0&id=dd8d961a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8d961a",
  null
  
)

export default component.exports